module.exports = __webpack_public_path__ + "img/activity_51.38d03a18.png";